import type { InferContractRouterOutputs } from '@orpc/contract'
import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import type { baseContract } from 'pixai-contract/api/orpc'
import type { Currency } from 'pixai-contract/payment/const'
import { useCallback } from 'react'
import { orpc } from './contract'

export type UserExtraPackageSku = InferContractRouterOutputs<
  typeof baseContract
>['extraPackage']['list']['data'][number]

export function useListExtraPackages(vars: {
  currency?: Currency
  promotionOption?: { extraPackageBoostCode?: string }
  enabled?: boolean
}) {
  return useQuery({
    ...orpc.extraPackage.list.queryOptions({
      input: {
        currency: vars.currency,
        promotionOption: vars.promotionOption,
      },
    }),
    select: res => res.data,
    enabled: vars.enabled,
    meta: { dependsOn: ['login'] },
    placeholderData: keepPreviousData,
  })
}

export function useInvalidateExtraPackageList() {
  const queryClient = useQueryClient()
  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: orpc.extraPackage.list.key(),
      }),
    [queryClient],
  )
}

export function usePurchaseExtraPackageMutation() {
  return useMutation(orpc.extraPackage.purchase.mutationOptions())
}
